module.exports = __webpack_public_path__ + "static/media/S1-R1-Recurso-codR1.e7b9eb89.png";